import { store } from "@store/store";
import { setInstrumentationData } from "@store/slices/globalState";

export const setInstrumentation = (payload) =>{
    const {instrumentationData} = payload
    store?.dispatch(setInstrumentationData(instrumentationData))
}

